module.exports = __webpack_public_path__ + "public/images/coding.142112d4d8a475338a9f8d193dad6dbd.png";